/**
 * Mutation-key tag shared by analytical-variable write mutations that
 * should surface in the project artifact list without a manual reload.
 * Lives in core-constants — not feature-analytical-variables — so
 * feature-project-page can import it without a build cycle (mirrors
 * `ANALYTICAL_DATASET_WRITE_MUTATION_KEY`).
 *
 * `useProjectPageAnalyticalVariableSync` (mounted in ProjectPage) subscribes
 * to the TanStack mutation cache and refreshes the project artifact manifest
 * on any write tagged with this key.
 */
export const ANALYTICAL_VARIABLE_WRITE_MUTATION_KEY = 'analytical-variable-write';
